module.exports = "/images/66f2f00f12feac4368785f6543cfd0b9.png";